import ContentDetailPageHeader from "../components/common/content/content-detail-page-header";
import ContentHeader from "../components/common/content/content-header";
import GeneralContentCard, {GeneralContentCardSkeleton} from "../components/common/content/general-content-card";
import {
  StyledContainer,
  StyledStack,
} from "../components/common/content/styles";
import { useEffect, useState } from "react";
import { ContentItem } from "../sanity/types";
import { getContentItemsByCategory } from "../sanity/queries";
import { fallbackMinistries } from "../sanity/fallbacks";
import {Seo} from "../seo/Seo";
import {AlertToast} from "../components/common/alert-toast";

export default function Ministries() {
  const [ministries, setMinistries] = useState<ContentItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    let isMounted = true;
    getContentItemsByCategory("ministry")
      .then((items: ContentItem[]) => {
        if (!isMounted) return;
        if (!items.length) {
          setMinistries(fallbackMinistries);
          setErrorMessage("Unable to load ministries. Showing fallback content.");
          return;
        }
        setErrorMessage("");
        setMinistries(items);
      })
      .catch(() => {
        if (isMounted) {
          setMinistries(fallbackMinistries);
          setErrorMessage("Unable to load ministries. Showing fallback content.");
        }
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <>
      <Seo
        title="Ministries"
        description="Explore ministries at St. George Coptic Orthodox Church, including youth programs, bible studies, choirs, and community outreach."
        path="/ministries"
      />
      <StyledContainer maxWidth={false}>
        <AlertToast
          open={!!errorMessage}
          message={errorMessage}
          onClose={() => setErrorMessage("")}
          severity="warning"
        />
      <ContentDetailPageHeader/>
        <ContentHeader title={"Ministries"} />
        <StyledStack>
          {loading
            ? [0, 1, 2].map((i) => (
                <GeneralContentCardSkeleton key={`ministry-skeleton-${i}`} />
              ))
            : (ministries.length ? ministries : fallbackMinistries).map(
                (ministry, index) => {
                  return (
                    <GeneralContentCard
                      key={ministry._id || index}
                      content={ministry}
                    />
                  );
                }
              )}
        </StyledStack>
      </StyledContainer>
    </>
  );
}
